import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LandingHeader from "../../components/landing/LandingHeader";
import LandingFooter from "../../components/landing/LandingFooter";
import { useTranslation } from "../../contexts/TranslationContext";
import "../../assets/css/landing.css";
import "./Home.css";
import "./LegalPage.css";

const PrivacyPolicy = () => {
  const { t, isRTL } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    document.body.classList.add("hl-body");
    return () => document.body.classList.remove("hl-body");
  }, []);

  // Ordered sections rendered as title + rich HTML content
  const sections = [
    "collect",
    "use",
    "sharing",
    "security",
    "retention",
    "rights",
    "thirdParty",
    "children",
    "internationalTransfers",
    "changes",
  ];

  return (
    <div className="hl-page hl-legal-page">
      <div className="hl-top-band">
        <LandingHeader />

        <div className="heading-policy flex-column">
          <h1>{t("privacyPolicy.title")}</h1>
        </div>
      </div>

      <div className="container data-info privacy-container" dir={isRTL ? 'rtl' : 'ltr'} style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>
        <div className="text-center privacy-meta">
          <p className="privacy-meta-text">{t("privacyPolicy.lastUpdated")}</p>
          <p className="privacy-meta-text">
            {t("privacyPolicy.website")} <a href={t("privacyPolicy.websiteUrl")} className="privacy-link"> {t("privacyPolicy.websiteUrl")} </a>
          </p>
        </div>
        <div className="privacy-heading privacy-content" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>
          <p className="privacy-section-content" dangerouslySetInnerHTML={{ __html: t("privacyPolicy.intro") }}></p>

          {sections.map((key) => (
            <React.Fragment key={key}>
              <h3 className={`privacy-section-title ${isRTL ? "mt-5" : "mt-4"}`}>
                {t(`privacyPolicy.${key}.title`)}
              </h3>
              <p
                className="privacy-section-content"
                dangerouslySetInnerHTML={{ __html: t(`privacyPolicy.${key}.content`) }}
              ></p>
            </React.Fragment>
          ))}

          <h3 className={`privacy-section-title ${isRTL ? "mt-5" : "mt-4"}`}>{t("privacyPolicy.contactUs.title")}</h3>
          <p className="privacy-section-content">{t("privacyPolicy.contactUs.intro")}</p>
          <div className="privacy-contact-info">
            <p className="privacy-section-content">{t("privacyPolicy.contactUs.company")}</p>
            <p className="privacy-section-content">{t("privacyPolicy.contactUs.website")}</p>
            <p className="privacy-section-content">{t("privacyPolicy.contactUs.email")}</p>
            {/* <p className="privacy-section-content">{t("privacyPolicy.contactUs.phone")}</p> */}
            <p className="privacy-section-content">{t("privacyPolicy.contactUs.address")}</p>
          </div>

          <p className="privacy-section-content privacy-legal-info mt-4">
            <em>{t("privacyPolicy.acknowledgment.content")}</em>
          </p>
        </div>
      </div>

      {/* Footer */}
      <LandingFooter />
    </div>
  );
};

export default PrivacyPolicy;
